import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
function useRegisteredTranslation(ns, translations, options) {
    const translation = useTranslation(ns, options);
    useEffect(() => {
        if (!translation.i18n.hasResourceBundle(translation.i18n.language, ns)) {
            translation.i18n.addResourceBundle(translation.i18n.language, ns, translations[translation.i18n.language]);
        }
    }, [ns, translation.i18n, translation.i18n.language, translations]);
    return translation;
}
export default useRegisteredTranslation;
